module.exports = __webpack_public_path__ + "static/media/live-oak.90765f4a.svg";